import { Text } from '@wartek-id/text'

import { Container } from '@/components/Container'
import { RoundedTable } from '@/components/RoundedTable/RoundedTable'

import { CustomMetadataCellRenderer } from './CustomMetadataCellRenderer'
import { METADATA_DATA_ITEMS_PTK } from '../data/metadata-ptk'
import { METADATA_DATA_ITEMS } from '../data/metadata-satpen-yayasan'
import { METADATA_DATA_FOOTNOTES } from '../data/metadata-shared-footnotes'

const META_DATA_COLUMNS = [
  {
    id: 'number',
    displayName: 'No',
  },
  {
    id: 'concept',
    displayName: 'Konsep',
    childColumns: [
      {
        id: 'objectClass',
        displayName: 'Kelas Objek',
      },
      {
        id: 'objectSubClass',
        displayName: 'Sub Kelas Objek',
      },
    ],
  },
  {
    id: 'variable',
    displayName: 'Nama Variabel',
  },
  {
    id: 'alias',
    displayName: 'Alias',
  },
  {
    id: 'definition',
    displayName: 'Definisi',
  },
  {
    id: 'selectionReference',
    displayName: 'Referensi Pemilihan',
  },
  {
    id: 'timeReference',
    displayName: 'Referensi Waktu',
  },
  {
    id: 'dataType',
    displayName: 'Tipe Data',
  },
  {
    id: 'inputClassification',
    displayName: 'Klasifikasi Isian',
  },
  {
    id: 'validationRules',
    displayName: 'Aturan Validasi',
  },
  {
    id: 'question',
    displayName: 'Kalimat Pertanyaan',
  },
  {
    id: 'isPublic',
    displayName: 'Dapat diakses publik',
  },
]

const META_DATA_COLUMNS_PTK = [
  {
    id: 'number',
    displayName: 'No',
  },
  {
    id: 'variable',
    displayName: 'Nama Variabel',
  },
  {
    id: 'concept',
    displayName: 'Konsep',
    childColumns: [
      {
        id: 'objectClass',
        displayName: 'Kelas Objek',
      },
      {
        id: 'objectSubClass',
        displayName: 'Sub Kelas Objek',
      },
    ],
  },
  {
    id: 'alias',
    displayName: 'Alias',
  },
  {
    id: 'definition',
    displayName: 'Definisi',
  },
  {
    id: 'selectionReference',
    displayName: 'Referensi Pemilihan',
  },
  {
    id: 'timeReference',
    displayName: 'Referensi Waktu',
  },
  {
    id: 'dataType',
    displayName: 'Tipe Data',
  },
  {
    id: 'inputClassification',
    displayName: 'Klasifikasi Isian',
  },
  {
    id: 'validationRules',
    displayName: 'Aturan Validasi',
  },
  {
    id: 'question',
    displayName: 'Kalimat Pertanyaan',
  },
  {
    id: 'publicText',
    displayName: 'Dapat diakses publik',
  },
]

const SUBHEADING = {
  'satpen-yayasan':
    'Metadata yang terkait dengan Satuan Pendidikan PAUD DIKDASMEN',
  ptk: 'Metadata yang terkait dengan Pendidik dan Tenaga Kependidikan',
}

export const MetaDataPanel = ({ jenis }: { jenis: string }) => {
  return (
    <Container className="mt-6">
      <Text variant="subheading" className="mb-6 uppercase">
        {SUBHEADING[jenis]}
      </Text>
      <RoundedTable
        columns={
          jenis === 'satpen-yayasan' ? META_DATA_COLUMNS : META_DATA_COLUMNS_PTK
        }
        // @ts-ignore
        data={
          jenis === 'satpen-yayasan'
            ? METADATA_DATA_ITEMS
            : METADATA_DATA_ITEMS_PTK
        }
        withSummary={false}
        CustomCellRenderer={({ row, col }) => {
          return <CustomMetadataCellRenderer row={row} col={col} />
        }}
      />

      {jenis === 'satpen-yayasan' && (
        <div className="mb-6 mt-4">
          <Text variant="heading-sm">Catatan Kaki:</Text>
          <ul className="mt-2">
            {METADATA_DATA_FOOTNOTES.map((itemNote) => (
              <li
                key={itemNote.sup}
                className="mb-4"
                id={`sup-${itemNote.sup}`}
              >
                <Text>
                  <Text color="informational" as="span">
                    {itemNote.sup}
                  </Text>
                  : {itemNote.definition}
                </Text>
                {itemNote.children && itemNote.children.length > 0 && (
                  <ol className="list-decimal pl-6">
                    {itemNote.children.map((itemChild) => (
                      <li key={itemChild.text} className="mb2">
                        <Text>{itemChild.text}</Text>
                      </li>
                    ))}
                  </ol>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </Container>
  )
}
